export type ConfigOptions = {
  expo: "yes" | "prebuild" | "no";
};

const default_config_options: ConfigOptions = {
  expo: "yes",
};

export const useConfigOptions = () => useLocalStorage<ConfigOptions>("config-options", () => default_config_options);
